import './Footer.css';

function Footer() {
  return (
    <div className="footer">
      <p>Learn more about <a href="#">JobFAX</a> here.</p>
    </div>
  );
}

export default Footer;
